export const EMPTY_FILTERS = {
  phaseId: "", search: "", costTypeIds: [], statuses: [],
  datePreset: "", dateFrom: "", dateTo: "", amountMin: "", amountMax: "",
};

export function deepFiltersFromParams(params) {
  const costTypeParam = params.get("cost_type");
  const statusParam   = params.get("status");
  return {
    phaseId:     params.get("phase")        || "",
    search:      params.get("search")       || "",
    costTypeIds: costTypeParam ? costTypeParam.split(",").map(Number).filter(Boolean) : [],
    statuses:    statusParam   ? statusParam.split(",").filter(Boolean) : [],
    datePreset:  params.get("date_preset")  || "",
    dateFrom:    params.get("date_from")    || "",
    dateTo:      params.get("date_to")      || "",
    amountMin:   params.get("amount_min")   || "",
    amountMax:   params.get("amount_max")   || "",
  };
}

export function applyFiltersToParams(filters, page) {
  const p = new URLSearchParams();
  if (filters.phaseId)                 p.set("phase",       filters.phaseId);
  if (page && page > 1)                p.set("page",        String(page));
  if (filters.search)                  p.set("search",      filters.search);
  if (filters.costTypeIds?.length > 0) p.set("cost_type",   filters.costTypeIds.join(","));
  if (filters.statuses?.length > 0)    p.set("status",      filters.statuses.join(","));
  if (filters.datePreset)              p.set("date_preset", filters.datePreset);
  if (filters.dateFrom)                p.set("date_from",   filters.dateFrom);
  if (filters.dateTo)                  p.set("date_to",     filters.dateTo);
  if (filters.amountMin)               p.set("amount_min",  filters.amountMin);
  if (filters.amountMax)               p.set("amount_max",  filters.amountMax);
  return p;
}

export function buildApiParams(page, filters) {
  const p = { page };
  if (filters.phaseId)                 p.phase      = filters.phaseId;
  if (filters.search)                  p.search     = filters.search;
  if (filters.costTypeIds?.length > 0) p.cost_type  = filters.costTypeIds.join(",");
  if (filters.statuses?.length > 0)    p.status     = filters.statuses.join(",");
  if (filters.dateFrom)                p.date_from  = filters.dateFrom;
  if (filters.dateTo)                  p.date_to    = filters.dateTo;
  if (filters.amountMin)               p.amount_min = filters.amountMin;
  if (filters.amountMax)               p.amount_max = filters.amountMax;
  return p;
}
